const BETTER_ID = 516770435;

export { BETTER_ID };
